<!DOCTYPE html>
<html lang="tr">
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">

<title>Sayfa bulunamadı — Frawgraphy</title>
<meta name="description" content="Aradığınız sayfa taşınmış ya da hiç var olmamış olabilir.">
<!-- Bulunamayan sayfa dizine girmemeli; kanonik etiket de yok, çünkü bu
     sayfanın temsil ettiği bir adres yok. -->
<meta name="robots" content="noindex, follow">

<link rel="icon" href="/favicon.ico" sizes="any">
<link rel="icon" type="image/png" sizes="32x32" href="/assets/img/favicon-32.png">
<link rel="icon" type="image/png" sizes="16x16" href="/assets/img/favicon-16.png">
<link rel="apple-touch-icon" sizes="180x180" href="/assets/img/apple-touch-icon.png">
<link rel="manifest" href="/site.webmanifest">

<meta name="theme-color" content="#060606" media="(prefers-color-scheme: dark)">
<meta name="theme-color" content="#f5f3f0" media="(prefers-color-scheme: light)">

<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Bodoni+Moda:ital,opsz,wght@0,6..96,400;0,6..96,500;0,6..96,700;0,6..96,900;1,6..96,400;1,6..96,700&family=Inter:wght@300;400;500;600&family=JetBrains+Mono:wght@400;500&display=swap">
<!-- Kök göreli (/): 404 her derinlikten servis edilir, /blog/yok da dahil. -->
<link rel="stylesheet" href="/assets/css/style.css?v=20260920b">
<noscript><style>.reveal{opacity:1;transform:none}</style></noscript>

<script>
  (function () {
    try {
      var t = localStorage.getItem('frawgraphy-theme');
      if (!t) t = matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
      document.documentElement.setAttribute('data-theme', t);
      document.documentElement.setAttribute('data-lang', localStorage.getItem('frawgraphy-lang') || 'tr');
    } catch (e) {
      document.documentElement.setAttribute('data-theme', 'dark');
      document.documentElement.setAttribute('data-lang', 'tr');
    }
  })();
</script>
</head>
<body data-title-key="notFound.docTitle">

<a class="skip-link" href="#main" data-i18n="skip">İçeriğe geç</a>

{{> header }}

{{> menu }}

<main id="main" class="page">
  <div class="shell">

{{{ pageHead }}}
  </div>
</main>

{{> footer }}

<script src="/assets/js/i18n.js?v=20260920b" defer></script>
<script src="/assets/js/main.js?v=20260920b" defer></script>
</body>
</html>
